import React, { useState } from 'react';
import { paymentsAPI, WithdrawReceipt } from '../lib/api';
import { Button } from './ui/button';

const ReceiptDownload: React.FC<{ transactionId: string; receipt: WithdrawReceipt }> = ({ transactionId, receipt }) => {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const filename = receipt.filename || 'receipt';
    const download = async () => {
        setBusy(true); setError('');
        try {
            if (receipt.id) await paymentsAPI.downloadWithdrawReceipt(transactionId, filename, receipt.id);
            else await paymentsAPI.downloadWithdrawReceipt(transactionId, filename);
        } catch {
            setError('Не удалось скачать чек. Попробуйте ещё раз.');
        } finally { setBusy(false); }
    };
    return <div className="space-y-2">
        <p className="text-sm break-all">Чек: {filename}</p>
        <Button variant="outline" size="sm" disabled={busy} onClick={download}>
            {busy ? 'Скачивание…' : 'Скачать чек'}
        </Button>
        {error && <p role="alert" className="text-sm text-red-600 dark:text-red-300">{error}</p>}
    </div>;
};

export const WithdrawReceiptDownload: React.FC<{
    transactionId: string; filename?: string; receipts?: WithdrawReceipt[];
}> = ({ transactionId, filename, receipts }) => {
    const items = receipts?.length ? receipts : filename ? [{ id: '', filename }] : [];
    return <div className="space-y-3">
        {items.map(receipt => <ReceiptDownload key={receipt.id} transactionId={transactionId} receipt={receipt} />)}
    </div>;
};
